import { render, staticRenderFns } from "./tabletwo.vue?vue&type=template&id=3b9ed2ad&scoped=true"
import script from "./tabletwo.vue?vue&type=script&lang=js"
export * from "./tabletwo.vue?vue&type=script&lang=js"
import style0 from "./tabletwo.vue?vue&type=style&index=0&id=3b9ed2ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9ed2ad",
  null
  
)

export default component.exports